module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Shipping Line Payment(Invoice wise)")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ffExportDetail.allModuleId ? _vm.ffExportDetail.allModuleId : '',
      "jobSeriesBanner": _vm.ffExportDetail.ffExportFclSeries ? _vm.ffExportDetail.ffExportFclSeries : '',
      "bannerClientName": _vm.ffExportDetail.clientName ? _vm.ffExportDetail.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.containerTypeDetailFactoryList.length > 0) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1), _vm._v(" "), _c('div', [(
    _vm.ContainerTypeSizefactory.ffExecutionContainerId != '' &&
    _vm.showMoreSB == false
  ) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showMoreSBDet
    }
  }, [_vm._v(_vm._s(_vm.showMoreSB == true ? "Show" : "Hide ") + " Container\n                    Details")]) : _vm._e()], 1), _vm._v(" "), (
    (_vm.getContainerList.length > 0 ||
      _vm.ContainerTypeSizefactory.ffExecutionContainerId != '') &&
    _vm.showMoreSB == false
  ) ? _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [(
    _vm.getContainerList.length > 0 ||
    _vm.ContainerTypeSizefactory.ffExecutionContainerId != ''
  ) ? _c('div', {
    staticClass: "gutr"
  }, [(_vm.showMoreSB == false) ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [(
    _vm.ContainerTypeSizefactory.ffExecutionContainerId ==
    ''
  ) ? _c('label', [_vm._v("Container Type/Size")]) : _vm._e(), _vm._v(" "), (
    _vm.ContainerTypeSizefactory.ffExecutionContainerId ==
    ''
  ) ? _c('model-list-select', {
    attrs: {
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "list": _vm.ContainerTypeList,
      "placeholder": "Select  Type/Size"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerTypeId", $$v)
      },
      expression: "ContainerTypeSizefactory.containerTypeId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerType"
    }
  }, [_vm._v("Container Type/Size")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerType),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerType", $$v)
      },
      expression: "ContainerTypeSizefactory.containerType"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.containerTypeId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No.(eg. AAAA1234567)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "containerNo"
    },
    on: {
      "keyup": _vm.containerNoRegexfun
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "containerNo", $$v)
      },
      expression: "ContainerTypeSizefactory.containerNo"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.containerNo))]) : (_vm.containerNoRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerNoRegexError))]) : _vm._e(), _vm._v(" "), (
    _vm.containerNoRegexError == '' &&
    _vm.ContainerTypeSizefactory.containerNo != '' &&
    _vm.ContainerTypeSizefactory.containerNo !=
    _vm.algoConNo &&
    _vm.showAlgo == true
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Note:System Generated Container No. is :\n                            " + _vm._s(_vm.algoConNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Net Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "netWeight",
      "name": "netWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.netWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "netWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.netWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Wgt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "grossWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.grossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerTypeSizefactory.grossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.grossWeight))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "weightUnit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.unitList,
      "option-value": "uV",
      "option-text": "uT",
      "placeholder": "Select Unit",
      "name": "weightUnit",
      "id": "weightUnit"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.weightUnit),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "weightUnit", $$v)
      },
      expression: "ContainerTypeSizefactory.weightUnit"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "minute-step": 1,
      "name": "handoverDate",
      "id": "handoverDate"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "handoverDate", $$v)
      },
      expression: "ContainerTypeSizefactory.handoverDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "customSealNo",
      "name": "customSealNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.customSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "customSealNo", $$v)
      },
      expression: "ContainerTypeSizefactory.customSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Line Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "LineSealNo",
      "name": "LineSealNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.LineSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "LineSealNo", $$v)
      },
      expression: "ContainerTypeSizefactory.LineSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Tare Wgt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tareWeight",
      "name": "tareWeight",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.tareWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "tareWeight", $$v)
      },
      expression: "ContainerTypeSizefactory.tareWeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Measurement (in CBM)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.measurement),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "measurement", $$v)
      },
      expression: "ContainerTypeSizefactory.measurement"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Package Details")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package Name"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.packageId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "packageId", $$v)
      },
      expression: "ContainerTypeSizefactory.packageId"
    }
  }), _vm._v(" "), (!_vm.ContainerTypeSizefactory.packageId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.packageId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No. of Packages (" + _vm._s(_vm.ContainerTypeSizefactory.packageName) + ")")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "noOfpkgUnit",
      "id": "noOfpkgUnit",
      "type": "number",
      "min": "0",
      "disabled": _vm.ContainerTypeSizefactory.packageName == '' ?
        true :
        false
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.noOfpkgUnit),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "noOfpkgUnit", $$v)
      },
      expression: "ContainerTypeSizefactory.noOfpkgUnit"
    }
  }), _vm._v(" "), (!_vm.ContainerTypeSizefactory.noOfpkgUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContainer.noOfpkgUnit))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Cargo Stuffing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "cargoStuffingDate",
      "id": "cargoStuffingDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.cargoStuffingDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "cargoStuffingDate", $$v)
      },
      expression: "ContainerTypeSizefactory.cargoStuffingDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("LEEO (Let Export Permit) Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "leeoDate",
      "id": "leeoDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.leeoDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "leeoDate", $$v)
      },
      expression: "ContainerTypeSizefactory.leeoDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("LEEO (Let Export Permit) No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "leeoNo",
      "id": "leeoNo"
    },
    model: {
      value: (_vm.ContainerTypeSizefactory.leeoNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerTypeSizefactory, "leeoNo", $$v)
      },
      expression: "ContainerTypeSizefactory.leeoNo"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body mt-2"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ffContainer"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Line Seal No.")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.containerTypeDetailFactoryList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdit(item.ffExecutionContainerId, index)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.containerNo) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdit(item.ffExecutionContainerId, index)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.containerType) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item.customSealNo != "" ? item.customSealNo : "--") + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item.LineSealNo != "" ? item.LineSealNo : "--") + "\n                        ")])])
  }))])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.SBDetail.ffSlinePayId != '' && _vm.accounts == false) ||
    (_vm.SBDetail.ffSlinePayId != '' && _vm.role == 'Admin')
  ) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.SBDetail.revisedMail),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "revisedMail", $$v)
      },
      expression: "SBDetail.revisedMail"
    }
  }), _c('span', {
    staticClass: "error"
  }, [_vm._v("Send Revised Payment Request")])], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "name": "POD",
      "id": "POD"
    },
    model: {
      value: (_vm.POD),
      callback: function($$v) {
        _vm.POD = $$v
      },
      expression: "POD"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("B/L No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
      "name": "POD",
      "id": "POD"
    },
    model: {
      value: (_vm.SBDetail.SlineBlNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "SlineBlNo", $$v)
      },
      expression: "SBDetail.SlineBlNo"
    }
  }), _vm._v(" "), (_vm.SBDetail.SlineBlNo == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.SlineBlNo))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [(_vm.ffExportDetail.jobType != 'MISC') ? _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "name": "POD",
      "id": "POD"
    },
    model: {
      value: (_vm.ffExportDetail.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ffExportDetail, "shippingLine", $$v)
      },
      expression: "ffExportDetail.shippingLine"
    }
  })], 1) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line ")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipplingLineList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExportDetail.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ffExportDetail, "shippingLine", $$v)
      },
      expression: "ffExportDetail.shippingLine"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Estimated SOB Date ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
      "lang": "en",
      "format": _vm.selectDateFormat,
      "name": "sobDate",
      "id": "sobDate",
      "minute-step": 1
    },
    on: {
      "input": _vm.getDueDate
    },
    model: {
      value: (_vm.SBDetail.sobDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "sobDate", $$v)
      },
      expression: "SBDetail.sobDate"
    }
  }), _vm._v(" "), (_vm.SBDetail.sobDate == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.sobDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Payment Due Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "disabled": "",
      "lang": "en",
      "name": "sobDate",
      "id": "sobDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.dueDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "dueDate", $$v)
      },
      expression: "SBDetail.dueDate"
    }
  })], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "my-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("B/L Draft By Shipping Line")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
      "name": "invoiceUpload",
      "id": "invoiceUpload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBlDraft('BL_DRAFT', 0)
      }
    },
    model: {
      value: (_vm.SBDetail.blDraftUpload),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "blDraftUpload", $$v)
      },
      expression: "SBDetail.blDraftUpload"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mb-2",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.viewBLDraftDoc.length > 0) ? _c('div', _vm._l((_vm.viewBLDraftDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "20"
      }
    }, [(_vm.ffExportDetail.ffExportFclSeries) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/ASSIGNMENT_UPLOADS/" +
          _vm.ffExportDetail.ffExportFclSeries.replaceAll('/', '_') +
          '/' +
          item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("--View Document - " + _vm._s(index + 1))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Sline_Payments_Uploads/" +
          item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("--View Document - " + _vm._s(index + 1))])])
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.addInvArry
    }
  }, [_vm._v("\n                Add Invoice "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._l((_vm.lineInvModalArray), function(itm, idx) {
    return _c('b-card', {
      key: idx,
      staticClass: "mt-2"
    }, [(idx != 0) ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvArry(idx)
        }
      }
    }, [_vm._v("\n                  Remove Invoice "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e(), _vm._v(" "), (
      _vm.SBDetail.revisedMail != 0
    ) ? _c('div', {
      staticClass: "mt-2"
    }, [_c('input', {
      attrs: {
        "id": 'checkbox-' + idx,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.addRevisedInvoice(idx, 'checkbox-' + idx)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v("Revise Invoice")])]) : _vm._e(), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice Category")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "multiple": "true",
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "list": _vm.invCategoryList,
        "option-value": "payVal",
        "option-text": "payText",
        "placeholder": "Select Category"
      },
      model: {
        value: (itm.invCategory),
        callback: function($$v) {
          _vm.$set(itm, "invCategory", $$v)
        },
        expression: "itm.invCategory"
      }
    })], 1)], 1), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', [_c('md-input-container', [_c('label', [_vm._v("Shipping Line Invoice")]), _vm._v(" "), _c('md-file', {
      attrs: {
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "name": "invoiceUpload",
        "id": "invoiceUpload"
      },
      on: {
        "selected": function($event) {
          _vm.onFileChangeBlDraft('Sline_Invoice', idx)
        }
      },
      model: {
        value: (itm.invSlineUpload),
        callback: function($$v) {
          _vm.$set(itm, "invSlineUpload", $$v)
        },
        expression: "itm.invSlineUpload"
      }
    })], 1)], 1), _vm._v(" "), _c('b-col', [_c('label', [_vm._v("Invoice No")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "name": "shippingBillNo",
        "id": "shippingBillNo"
      },
      model: {
        value: (itm.invNo),
        callback: function($$v) {
          _vm.$set(itm, "invNo", $$v)
        },
        expression: "itm.invNo"
      }
    })], 1), _vm._v(" "), _c('b-col', [_c('label', [_vm._v("Invoice Type")]), _vm._v(" "), _c('multi-select', {
      attrs: {
        "options": _vm.invoiceTypeList,
        "selected-options": _vm.items,
        "placeholder": "select Type"
      },
      on: {
        "select": function (item) {
          _vm.onSelect(idx, item)
        }
      }
    })], 1)], 1), _vm._v(" "), (_vm.viewInvDoc.length > 0) ? _c('div', [_c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, _vm._l((_vm.viewInvDoc), function(item, index) {
      return _c('md-layout', {
        key: index,
        attrs: {
          "md-flex": "40"
        }
      }, [(_vm.ffExportDetail.ffExportFclSeries) ? _c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.ffExportDetail.ffExportFclSeries.replaceAll('/', '_')) + "/" + item))
          }
        }
      }, [_vm._v("--View Document - " + _vm._s(index + 1))]) : _vm._e(), _c('br'), _vm._v(" "), _c('a', {
        attrs: {
          "href": _vm.docURL + "/FF_Sea_Export_Sline_Payments_Uploads/" +
            item,
          "target": "_blank",
          "download": ""
        }
      }, [_vm._v("--View Document - " + _vm._s(index + 1))])])
    }))], 1) : _vm._e(), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center mt-3"
    }, [_c('b-button', {
      staticClass: "ml-3",
      attrs: {
        "id": "show-btn",
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          _vm.addInvCurrency(idx)
        }
      }
    }, [_vm._v("\n                        ADD AMOUNT "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)]), _vm._v(" "), _vm._l((itm['invCurrencyList']), function(currItm, currIdx) {
      return _c('b-card', {
        key: currIdx,
        staticClass: "mt-2"
      }, [_c('div', [(currIdx != 0) ? _c('b-row', [_c('b-col', [_c('div', {
        staticClass: "d-flex align-items-center mt-3"
      }, [_c('b-button', {
        staticClass: "ml-auto",
        attrs: {
          "id": "show-btn",
          "size": "sm",
          "variant": "outline-danger"
        },
        on: {
          "click": function($event) {
            _vm.removeInvCurrency(idx, currIdx)
          }
        }
      }, [_vm._v("\n                          REMOVE AMOUNT "), _c('i', {
        staticClass: "fa fa-plus",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
        attrs: {
          "cols": "3"
        }
      }, [_c('label', [_vm._v("Invoice Amount")]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "formatter": _vm.capitalizeAll,
          "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
          "name": "shippingBillNo",
          "id": "shippingBillNo"
        },
        model: {
          value: (currItm.invAmount),
          callback: function($$v) {
            _vm.$set(currItm, "invAmount", $$v)
          },
          expression: "currItm.invAmount"
        }
      })], 1), _vm._v(" "), _c('b-col', {
        attrs: {
          "cols": "3"
        }
      }, [_c('label', [_vm._v("Currency")]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
          "list": _vm.currList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Currency"
        },
        model: {
          value: (currItm.invCurrency),
          callback: function($$v) {
            _vm.$set(currItm, "invCurrency", $$v)
          },
          expression: "currItm.invCurrency"
        }
      })], 1), _vm._v(" "), (
        (_vm.SBDetail.ffSlinePayId != '' && _vm.accounts == false) ||
        (_vm.SBDetail.ffSlinePayId != '' && _vm.role == 'Admin')
      ) ? _c('b-col', [_c('label', [_vm._v("Payment Mode")]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "list": _vm.payList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Mode"
        },
        model: {
          value: (currItm.invPayMode),
          callback: function($$v) {
            _vm.$set(currItm, "invPayMode", $$v)
          },
          expression: "currItm.invPayMode"
        }
      })], 1) : _vm._e(), _vm._v(" "), (
        (_vm.SBDetail.ffSlinePayId != '' && _vm.accounts == false) ||
        (_vm.SBDetail.ffSlinePayId != '' && _vm.role == 'Admin')
      ) ? _c('b-col', [_c('label', [_vm._v("Payment Ref")]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "formatter": _vm.capitalizeAll,
          "name": "shippingBillNo",
          "id": "shippingBillNo"
        },
        model: {
          value: (currItm.invPayRef),
          callback: function($$v) {
            _vm.$set(currItm, "invPayRef", $$v)
          },
          expression: "currItm.invPayRef"
        }
      })], 1) : _vm._e()], 1), _vm._v(" "), (
        (_vm.SBDetail.ffSlinePayId != '' && _vm.accounts == false) ||
        (_vm.SBDetail.ffSlinePayId != '' && _vm.role == 'Admin')
      ) ? _c('b-row', [_c('b-col', {
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Amount")]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "formatter": _vm.capitalizeAll,
          "name": "shippingBillNo",
          "id": "shippingBillNo"
        },
        model: {
          value: (currItm.invPaidAmount),
          callback: function($$v) {
            _vm.$set(currItm, "invPaidAmount", $$v)
          },
          expression: "currItm.invPaidAmount"
        }
      })], 1), _vm._v(" "), _c('b-col', {
        staticClass: "mt-4",
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('date-picker', {
        attrs: {
          "format": _vm.selectDateFormat,
          "lang": "en",
          "name": "shippingBillNo",
          "id": "shippingBillNo",
          "minute-step": 1
        },
        model: {
          value: (currItm.invPayDate),
          callback: function($$v) {
            _vm.$set(currItm, "invPayDate", $$v)
          },
          expression: "currItm.invPayDate"
        }
      })], 1), _vm._v(" "), _c('b-col', {
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Status")]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "list": _vm.statusList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Status"
        },
        model: {
          value: (currItm.invPayStatus),
          callback: function($$v) {
            _vm.$set(currItm, "invPayStatus", $$v)
          },
          expression: "currItm.invPayStatus"
        }
      })], 1), _vm._v(" "), _c('b-col')], 1) : _vm._e()], 1)], 1)])
    })], 2)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.lineInvModalArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addSBDetail
    }
  }, [_vm._v("Save & Submit\n                  ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1)], 2), _vm._v(" "), (_vm.suplimentaryInvData.length > 0) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('h5', [_vm._v("Supplementary Invoice")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Invoice Added Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Invoice Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SOB Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Due Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Payment Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount Paid")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Payment Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _vm._l((_vm.suplimentaryInvData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.loginTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.invoiceAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sobDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dueDate))]), _vm._v(" "), _c('td', {
      attrs: {
        "bgcolor": item.paymentDone == '1' ? 'Green' : 'Red'
      }
    }, [_vm._v("\n                      " + _vm._s(item.paymentDone == "1" ? "Completed" : "Pending") + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.payDate))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function($event) {
          _vm.getSingleSupPay(item.supffSlinePayId)
        }
      }
    }, [_vm._v("Edit / Make Payment")])], 1)])
  })], 2)])]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal",
    attrs: {
      "id": "supModal",
      "size": "xl",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('suplimentry-inv', {
    key: _vm.componentKey,
    attrs: {
      "suplimentaryInvDataSingleArry": _vm.getSuplimentaryInvData
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06312110","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/miscInvoiceSlinePayment.vue
// module id = 2366
// module chunks = 0